import { RefObject } from 'react';
import { StickyPriceCard } from '../components/page-sections/sticky-price-card/index';
export const renderStickyBar = (
  ref: RefObject<HTMLDivElement>,
  visible: boolean
) => {
  if (!ref.current) return <></>;
  return visible ? <></> : <StickyPriceCard />;
};

export const getPercentageDiff = (a: number, b: number): number => {
  if (isNaN(a) || isNaN(b) || !a) return 0;
  return Math.floor((1 - b / a) * 100);
};
